import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContext } from '../../provider/BreadcrumbItemContextProvider';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MetadataContentTabs } from '../../ui-parts/MetadataContentTabs';

/** MyMine Version2.0 TrainingLv2SubLv2画面新規追加
* Trainingv2SubLv2 Page Content
*/
export const TrainingLv2SubLv2 = () => {
  const screenId = 'MyM319';
  const { controlSettings, messageList } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const queryParam = useParams();
  const { setBreadcrumbItem } = useContext(BreadcrumbItemContext);

  useEffect(() => {
    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestTraingScheduleContents = (result) => {
      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestTrainingScheduleContents();
        return;
      }

      // パンくずリストにMetadataNameを設定
      setBreadcrumbItem(result.ModelMetadataName);
      setContent(result);
      setIsLoading(false);
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestTrainingScheduleContents = () => {
      setIsLoading(false);
    }


    // 表示情報取得
    apiRequest.requestJson(`api/training/lv2-2/?metadataId=${queryParam.metadata_id}`, 'GET', callbackSuccessRequestTraingScheduleContents, callbackFailedRequestTrainingScheduleContents);

    // アンマウント時、パンくずリストのコンテキストをクリア
    return () => {
      setBreadcrumbItem(null);
    }
  }, []);

  if (queryParam.metadata_id === '0') {
    return (
      <Box className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
        <MyMLabel fontSize='25px'>{messageList.MyM_MSG_I_0059}</MyMLabel>
      </Box>
    );
  }

  const TrainingLv2Label =
    controlSettings.LabelList['lblTrainingLv2Massage_' + queryParam.metadata_id];

  const TrainingLv2Message =
    controlSettings.LabelList['lblTrainingLv2Text_' + queryParam.metadata_id];

  if (content == null)
    return <MyMProgress />

  return (
    <Box className='py-1 d-flex flex-column'>
      {isLoading && <MyMProgress />}
      <Box className='mb-4'>
        <MyMVariantLabel variant='h5'>{TrainingLv2Label}</MyMVariantLabel>
        <MyMLabel>{TrainingLv2Message}</MyMLabel>
      </Box>
      <Grid container className='pb-2 flex-grow-1'>
        <Grid item xs={0.5} md={0.5} />
        <Grid item xs={11} md={11}>
          <MetadataContentTabs
            paramMetadataId={queryParam.metadata_id}
            screenId={screenId}
            metadataContent={content}
            setIsLoading={setIsLoading}
            // 2025.3.5 MyMine Version2.1対応 Add Start
            isDefaultOpenFirstAccordion={true}
            // 2025.3.5 MyMine Version2.1対応 Add End
          />
        </Grid>
        <Grid item xs={0.5} md={0.5} />
      </Grid>
    </Box>
  );
}

export default TrainingLv2SubLv2;
